import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Table from './Table';

const SiteStatuses = () => {
  const { user } = useSelector((state) => state.authReducer);
  const [canUpdate, setCanUpdate] = useState(false);
  const [canDelete, setCanDelete] = useState(false);

  useEffect(() => {
    if (user?.permissions?.site_statuses?.add_edit) {
      setCanUpdate(true);
    }
    if (user?.permissions?.site_statuses?.delete) {
      setCanDelete(true);
    }
  }, [user]);

  return (
    <div className='page-top-div'>
      <span className='text-span'>Site Statuses Manager</span>
      <Table canUpdate={canUpdate} canDelete={canDelete} />
    </div>
  );
};

export default SiteStatuses;
